import React, { useEffect, useState } from 'react';
import analytics from '../utils/analytics';
import {
  APP_STORE_URL,
  PLAY_STORE_URL,
  handleAppStoreClick,
  handlePlayStoreClick,
} from '../utils/appStoreLinks';
import './MobileAppDownloadModal.css';

const MobileAppDownloadModal = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isIOS, setIsIOS] = useState(true);

  useEffect(() => {
    // Check if already dismissed
    if (localStorage.getItem('mobileAppBannerDismissed')) {
      setIsVisible(false);
      return;
    }

    // Detect device type
    const userAgent = navigator.userAgent.toLowerCase();
    setIsIOS(/iphone|ipad|ipod/.test(userAgent));
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('mobileAppBannerDismissed', 'true');
  };

  // Expose banner presence so floating UI (e.g. profile close button)
  // can clear the fixed 50px top banner. Desktop CSS hides the banner,
  // so the class is harmless there.
  useEffect(() => {
    document.body.classList.toggle('has-top-banner', isVisible);
    return () => document.body.classList.remove('has-top-banner');
  }, [isVisible]);

  const handleDownload = () => {
    const store = isIOS ? 'ios' : 'android';
    analytics.trackAppStoreBadgeClick(store, 'mobile_banner');
    // Central referral handoff (clipboard copy on iOS) — never awaited.
    if (isIOS) {
      handleAppStoreClick();
      window.open(APP_STORE_URL, '_blank');
    } else {
      handlePlayStoreClick();
      window.open(PLAY_STORE_URL, '_blank');
    }
  };

  if (!isVisible) return null;

  return (
    <div className="mobile-app-download-modal">
      <div className="modal-content-mobileappdownload">
        <div className="modal-text">
          <h2>Get the App Now!</h2>
        </div>

        <button className="modal-badge-btn" onClick={handleDownload}>
          <img 
            src={isIOS ? '/assets/badges/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg' : '/assets/badges/GetItOnGooglePlay_Badge_Web_color_English.png'}
            alt={isIOS ? 'Download on the App Store' : 'Get it on Google Play'}
            className="modal-badge-img"
          />
        </button>

        <button className="modal-dismiss-btn" onClick={handleDismiss}>
          ×
        </button>
      </div>
    </div>
  );
};

export default MobileAppDownloadModal;
